import {
  Button,
  Checkbox,
  Flex,
  Loader,
  Modal,
  Textarea,
  Title,
} from "@mantine/core";
import { SendRunningLate } from "api";
import ModalWrapper from "components/ModalWrapper/ModalWrapper";
import { useState } from "react";
import { useUser } from "stores/useUser";
import { attendeesWithout, notify } from "utils/common";

const RunningLateModal = ({ opened, setOpened, event }) => {
  const { organizer, attendees, title } = event;
  const { user } = useUser();
  const handleClose = () => {
    setOpened(false);
  };
  const [CCMeCheck, setCCMeCheck] = useState(true);
  const [attendeesCheck, setAttendeesCheck] = useState(true);
  const [organizerCheck, setOrganizerCheck] = useState(!organizer.self);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(
    `I will be running late by 10 minutes for ${title}`
  );
  const handleSendMessage = async () => {
    setLoading(true);
    // first do logic without including organizer
    let data = {
      senderEmail: user.email,
      message,
      userUid: user.uid,
      toEmails: [],
      ccEmails: [],
    };
    let recipients = [];
    if (attendeesCheck) {
      // excluding the organizer and self
      recipients.push(
        ...attendeesWithout(attendees, user.email)
          .filter((person) => person.email !== organizer.email)
          .map((attendee) => attendee.email)
      );
      data.toEmails = recipients;
    }
    if (CCMeCheck) {
      data.ccEmails.push(user.email);
    }

    // check if you are not the organizer then do logic for organizer inclusion
    if (!organizer.self) {
      if (organizerCheck) {
        data.toEmails.push(organizer.email);
      }
    }
    try {
      await SendRunningLate(data);
      notify("Message sent successfully", "success");
    } catch (e) {
      console.log(e);
      notify("Error while sending message", "error");
    } finally {
      setLoading(false);
    }
    setOpened(false);
    return data;
  };

  return (
    <Modal
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={opened}
      onClose={() => handleClose()}
    >
        <ModalWrapper
          type={"email"}
        >
          <Title order={4} mb={13} align="center">
            {event.title}
          </Title>
          <Textarea
            autosize
            minRows={3}
            maxRows={10}
            label="Email Body"
            value={message}
            onChange={(e) => setMessage(e.currentTarget.value)}
          />

          <Flex direction="row" gap={20} my={20}>
            {/* checkbox to also send to yourself */}
            <Checkbox
              label="Me"
              checked={CCMeCheck}
              onChange={(event) => setCCMeCheck(event.currentTarget.checked)}
            />

            {/* if you are not the organizer then enable send to organizer checkbox */}
            {!organizer.self && (
              <Checkbox
                label="Organizer"
                checked={organizerCheck}
                onChange={(event) =>
                  setOrganizerCheck(event.currentTarget.checked)
                }
              />
            )}

            {/* checkbox to send to all attendess except organizer */}
            <Checkbox
              label="Attendees"
              checked={attendeesCheck}
              onChange={(event) =>
                setAttendeesCheck(event.currentTarget.checked)
              }
            />
          </Flex>
          <Button
            onClick={handleSendMessage}
            sx={{ marginLeft: "81%" }}
            disabled={(!attendeesCheck && !organizerCheck) || loading}
          >
            {/* if organizer.self then remove the user.email from the attendees array, also make the whole array members unique */}
            {loading ? <Loader size={20} variant="dots" /> : "Send"}
          </Button>
        </ModalWrapper>
    </Modal>
  );
};

export default RunningLateModal;
